import { useSelector } from 'react-redux';

import GlobalSelectors from '../store/global-selectors';

export const ShipStationFulfillmentProviderId = '25';

export const useSellerShipStationFulfillmentProvider = () => {
  const sellerFulfillmentProviders = useSelector(GlobalSelectors.selectSellerActiveFulfillmentProviders);
  return sellerFulfillmentProviders.find((f) => f.fulfillmentProviderId === ShipStationFulfillmentProviderId);
};

export const useIsFulfillmentsTabVisible = () => {
  const hasActiveShipStationFulfillmentProvider = useSellerShipStationFulfillmentProvider();
  return !!hasActiveShipStationFulfillmentProvider;
};
